import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');
const filter = require('lodash/filter');

const Globals = require('../../../../app/globals');
const KeyboardUtil = require('../../util/keyboard');
const ChannelActions = require('../../actions/ChannelActions');
const ChannelStore = require('../../stores/channel_store_reflux');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    folderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    channelName: PropTypes.string.isRequired,
    folderName: PropTypes.string,
    contentType: PropTypes.oneOf([Globals.content_type.ACTIVITY, Globals.content_type.COURSE]).isRequired,
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
};

const defaultProps = {
    folderId: '',
    folderName: '',
    show: false,
};

class NewFolderModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            channelStoreState: ChannelStore.getState(),
            folderName: '',
            actionId: null,
            error: null,
            uiErrors: {},
        };
        this.inputElem = React.createRef();
        this.newProjectHandler = this.newProjectHandler.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.unsubscribes = [
            ChannelStore.listen(this.onChannelStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        this.focusOnInput();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onChannelStoreChange(state) {
        let additionalState = {};

        if (state.action.id === this.state.actionId) {
            if (!state.action.error) {
                this.props.closeHandler();
                return;
            }
            else {
                let uiErrors = {};
                if (state.action.error.uiRefs) {
                    state.action.error.uiRefs.forEach((ref) => {
                        uiErrors[ref] = true;
                    });
                }

                additionalState = { ...additionalState, error: state.action.error, uiErrors: uiErrors };
            }

            additionalState = { ...additionalState, actionId: null };
        }

        this.setState({ channelStoreState: state, ...additionalState });
    }

    newProjectHandler(folderName) {
        const actionId = uuid.v4();
        this.setState({ actionId:  actionId }, () => {

            if (!this.props.folderId) {
                ChannelActions.createFolder(actionId, {
                    channelId: this.props.channelId,
                    name: this.state.folderName,
                    contentType: this.props.contentType,
                });
            }
            else {
                ChannelActions.createSubfolder(actionId, {
                    folderId: this.props.folderId,
                    name: this.state.folderName,
                });
            }
        });
    }

    onChangeName(e) {
        this.setState({ folderName: e.target.value });
    }

    handleKeyDown(e) {
        e.stopPropagation();
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            e.preventDefault();
            this.newProjectHandler();
        }
    }

    focusOnInput() {
        const inputElem = this.inputElem.current;
        if (!inputElem) return;

        inputElem.focus();
    }

    render() {
        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>new folder</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <Form.Group controlId="new-folder-modal-input">
                            <div className="font-size-md margin-bottom-md">
                                Creating folder in:
                                <div className="margin-top-sm">
                                    {this.props.channelName} {!!this.props.folderName && `- ${this.props.folderName}`}
                                </div>
                            </div>
                            <Form.Label>folder name</Form.Label>
                            <Form.Control
                                ref={this.inputElem}
                                aria-label={this.props.ariaLabel}
                                value={this.state.folderName}
                                onChange={this.onChangeName}
                                onKeyDown={this.handleKeyDown}
                                isInvalid={this.state.uiErrors['input']}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={!!this.state.actionId}
                        onClick={this.newProjectHandler}
                    >
                        create
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

 NewFolderModal.propTypes = propTypes
 NewFolderModal.defaultProps = defaultProps;

 export default NewFolderModal;